import { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import PostCard, { type Post } from '../../components/agora/PostCard'

export default function SeriesPage() {
  const { name } = useParams<{ name: string }>()
  const [posts, setPosts] = useState<Post[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!name) return
    fetch(`/api/agora/series/${encodeURIComponent(name)}`)
      .then(r => r.json())
      .then(d => { setPosts(d.posts || []); setLoading(false) })
      .catch(() => setLoading(false))
  }, [name])

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 40, color: 'var(--text-muted)' }}>
        Loading series...
      </div>
    )
  }

  return (
    <div style={{ maxWidth: 700, margin: '0 auto', padding: '24px 16px' }}>
      <Link to="/agora" style={{ fontSize: 12, color: 'var(--text-muted)', textDecoration: 'none', marginBottom: 16, display: 'block' }}>
        ← Back to Agora
      </Link>

      <h1 style={{
        fontFamily: 'Playfair Display, Georgia, serif',
        fontSize: 24, fontWeight: 700, marginBottom: 8,
        color: 'var(--text-primary)',
      }}>
        📚 {name}
      </h1>
      <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 24 }}>
        {posts.length} {posts.length === 1 ? 'part' : 'parts'} in this series
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {posts.map((post, i) => (
          <div key={post.id}>
            <div style={{ fontSize: 11, color: '#6FB8D6', fontWeight: 600, marginBottom: 6 }}>
              Part {i + 1} of {posts.length}
            </div>
            <PostCard post={post} mockupHost="/tools/agora" />
            {i < posts.length - 1 && (
              <div style={{ textAlign: 'center', padding: '8px 0', color: 'var(--text-muted)', fontSize: 18 }}>
                ↓
              </div>
            )}
          </div>
        ))}
      </div>

      {posts.length === 0 && (
        <div style={{ textAlign: 'center', padding: 40, color: 'var(--text-muted)', fontSize: 13 }}>
          No posts in this series yet.
        </div>
      )}
    </div>
  )
}
